export * from "./complimentary-price-box.component";
